import { useState } from 'react';
import { Box, Stack } from '@mui/material';
import React from 'react';
import Fan2FanItem from './Fan2FanItem';
import useEventContext from '@/contexts/event/useEventContext';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import useMobile from '@/hooks/useMobile';
import { useEffect } from 'react';

export default function Fan2FanTickets({ link, setShowFan2Fan }) {
  const { secondaryMarketTiketsAvailable } = useAnalyticsEvents();
  const { isMobile } = useMobile()

  const {
    event: {
      event: { id, name },
    },
  } = useEventContext();

  useEffect(() => {
    secondaryMarketTiketsAvailable({ event_id: id, event_name: name });
  }, []);

  return (
    <Stack gap={1}>
      <Box
        sx={{
          fontWeight: 500,
          fontSize: isMobile ? '14px' : '16px',
          margin: '16px 0 2px 0',
        }}
      >
        ¿No ves los boletos que buscas?
      </Box>
      <Fan2FanItem
        onClick={() => setShowFan2Fan({ open: true, link })}
        data={{ event_id: id, event_name: name }}
      />
    </Stack>
  );
}
